module.exports = __webpack_public_path__ + "img/mistakesText9.6b8a6646.png";